export const VITE_HUB_SERVICE_URL: string = import.meta.env.VITE_HUB_SERVICE_URL;
export const VITE_FF_SERVICE_URL: string = import.meta.env.VITE_FF_SERVICE_URL;
export const VITE_PLUGIN_SERVICE_URL: string = import.meta.env.VITE_PLUGIN_SERVICE_URL;
export const VITE_MASSIVE_LOAD_URL: string = import.meta.env.VITE_MASSIVE_LOAD_URL;
export const VITE_3CLICKS: string = import.meta.env.VITE_3CLICKS;
export const VITE_UPS_SERVICE: string = import.meta.env.VITE_UPS_SERVICE;
export const VITE_UPS_WIDGET: string = import.meta.env.VITE_UPS_WIDGET;
export const VITE_MAPLIBRE_STYLE_URL: string = import.meta.env.VITE_MAPLIBRE_STYLE_URL;
export const VITE_GOOGLE_MAPS_API_KEY: string = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const VITE_ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT;

export const VITE_AUTH0_DOMAIN: string = import.meta.env.VITE_AUTH0_DOMAIN;
export const VITE_AUTH0_CLIENT_ID: string = import.meta.env.VITE_AUTH0_CLIENT_ID;

export const USER_AGENT: string = 'hub-platform-v4/1.0.0';

/**
 * HTTP timeout configurations (in milliseconds)
 *
 * FULFILL_HTTP_TIMEOUT: Extended timeout for Fulfill services (30s)
 * DEFAULT_HTTP_TIMEOUT: Default timeout for all other services (25s)
 * Note: Other services use the default ky timeout (10s)
 */
export const FULFILL_HTTP_TIMEOUT = 30000; // 30 segundos
export const DEFAULT_HTTP_TIMEOUT = 25000; // 25 segundos

/**
 * Label download batch configuration
 *
 * LABELS_BATCH_SIZE: Maximum number of tracking IDs per label download request.
 * If the total exceeds this limit, the download is split into sequential batches.
 */
export const LABELS_BATCH_SIZE = 150;

/**
 * Production environment indicator
 */
export const IS_PROD = import.meta.env.PROD;
